"use strict";
/**
 * @module Services.Metrics
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var measured_entity_class_request_1 = require("./../../services/metrics/measured-entity-class-request");
/**
 * Serialiser for {@link MeasuredEntityClassRequest}
 */
var MeasuredEntityClassRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MeasuredEntityClassRequestSerialiserClass, _super);
    function MeasuredEntityClassRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link MeasuredEntityClassRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the instance that was read
     */
    MeasuredEntityClassRequestSerialiserClass.prototype.read = function (bis) {
        var entityClass = Codec.readString(bis);
        var serverName = Codec.readByte(bis) === 1 ? Codec.readString(bis) : undefined;
        return new measured_entity_class_request_1.MeasuredEntityClassRequest(entityClass, serverName);
    };
    /**
     * Write a {@link MeasuredEntityClassRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the instance to be written
     */
    MeasuredEntityClassRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.entityClass);
        if (value.serverName !== undefined) {
            Codec.writeByte(bos, 1);
            Codec.writeString(bos, value.serverName);
        }
        else {
            Codec.writeByte(bos, 0);
        }
    };
    return MeasuredEntityClassRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MeasuredEntityClassRequestSerialiserClass = MeasuredEntityClassRequestSerialiserClass;
/**
 * The singleton
 */
// tslint:disable-next-line:variable-name
exports.MeasuredEntityClassRequestSerialiser = new MeasuredEntityClassRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metrics/measured-entity-class-request-serialiser.js
// module id = 1980
// module chunks = 1